import { isNotNull } from '@allurion/utils';
import _, { sortBy } from 'lodash';

import { IClinic } from '../hooks/useClinics';

import { TLocatorStore } from './useLocatorStore';

export function sortedClinicsWithDistance(state: TLocatorStore, clinics: IClinic[]): IClinic[] {
  if (!state.currentLocation) return clinics;

  const clinicsWithDistance = clinics.map((clinic) => {
    const distanceInMetres = calculateDistanceInMetres(state.currentLocation!, {
      lat: clinic.Geolocation__c.latitude,
      lng: clinic.Geolocation__c.longitude,
    });

    return {
      ...clinic,
      distanceInMetres,
    };
  });

  let sortedClinics: IClinic[] = clinicsWithDistance;

  if (state.sortClinicsBy === 'distance') {
    // Sort only by distance
    sortedClinics = sortBy(clinicsWithDistance, 'distanceInMetres');
  }

  return sortedClinics;
}

function calculateDistanceInMetres(
  currentLocation: google.maps.LatLngLiteral,
  clinicLocation: google.maps.LatLngLiteral
) {
  // Convert coordinates to LatLng objects
  const currentLocationLatLng = new google.maps.LatLng(currentLocation.lat, currentLocation.lng);
  const clinicLatLng = new google.maps.LatLng(clinicLocation.lat, clinicLocation.lng);

  // Use computeDistanceBetween to calculate distance in meters
  const distanceInMetres = google.maps.geometry.spherical.computeDistanceBetween(
    currentLocationLatLng,
    clinicLatLng
  );

  return distanceInMetres;
}

export function uniqueSortedCountriesSelector({ clinics }: { clinics: IClinic[] }): string[] {
  // Extract the BillingCountry values from the clinics
  const billingCountries: string[] = clinics
    .map((clinic) => clinic.BillingCountry)
    .filter(isNotNull);
  const sortedBillingCountries: string[] = _.sortBy(billingCountries);
  const uniqueBillingCountries: string[] = _.uniq(sortedBillingCountries);

  return uniqueBillingCountries;
}

export function clinicsWithMatchingCoordinatesSelector(
  activeClinic: IClinic | undefined,
  clinics: IClinic[]
): IClinic[] {
  if (!activeClinic) return [];

  return clinics.filter(
    (clinic) =>
      clinic.Geolocation__c.latitude === activeClinic.Geolocation__c.latitude &&
      clinic.Geolocation__c.longitude === activeClinic.Geolocation__c.longitude
  );
}

export function clinicsWithDuplicateCoordinatesSelector(clinics: IClinic[]) {
  const groupedClinics = _.groupBy(clinics, (clinic) => {
    const { latitude, longitude } = clinic.Geolocation__c;

    return `${latitude}_${longitude}`;
  });

  const duplicateGroups = _.pickBy(groupedClinics, (group) => group.length > 1);

  const clinicsWithDuplicates = _.flatMap(duplicateGroups);

  return clinicsWithDuplicates;
}
